import React from 'react';
import {
  Modal,
  View,
  TouchableWithoutFeedback,
} from 'react-native';

interface CenteredModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const CenteredModal: React.FC<CenteredModalProps> = ({
  visible,
  onClose,
  children,
}) => {
  if (!visible) return null;

  return (
    <Modal
      visible
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View className="absolute inset-0 bg-black/45" />
      </TouchableWithoutFeedback>

      <View
        className="absolute inset-0 justify-center items-center"
        style={{ paddingHorizontal: '20%' }}
        pointerEvents="box-none"
      >
        {children}
      </View>
    </Modal>
  );
};
